import React, { Component } from 'react';
import Sidebar from '../sidebar/sidebar';
import Serviceblock from '../serviceblock/serviceblock';
import { connect } from 'react-redux';
import { featuredImage } from '../../utilities';
import './services.css';
import get from 'lodash.get';
import has from 'lodash.has';
import {Helmet} from "react-helmet";

class Services extends Component {

    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        return (
            <div className="services">
                <Helmet>
                    <title>Wat we doen - KWOOT</title>
                    <meta property="og:title" content={"Wat we doen - KWOOT"} />
                </Helmet>
                <Sidebar title="Wat we doen" description={ get(this.props, 'postOptions.sidebar_description', '') } image={get(this.props, 'postOptions.sidebar_afbeelding.sizes.medium_large','')} menuwhite={false} logoblack={true}/>
                <div className="services__content">
                    {
                        this.props.services.map((service, index) => {
                            return (
                                <Serviceblock key={service.id} slug={service.slug} id={service.id} title={service.title.rendered} icon={service.diensticon} image={featuredImage(service, 'large')} link={service.link}/>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {

    let services = [];
    let postOptions = {};

    if (store.services && store.services.services) {
        services = store.services.services;
    }

    if (has(store, 'site.options.posttype.services')) {
        postOptions = get(store, 'site.options.posttype.services');
    }

    return {
        services: services,
        postOptions: postOptions
    }
}

export default connect(mapStateToProps)(Services);



// WEBPACK FOOTER //
// ./src/components/services/services.js